import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DonateButton from "./DonateButton";

const Header = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  const navigate = useNavigate();
  const startNow = () => {
    navigate("/home");
  };

  return (
    <header className="header">
      <div className="background-overlay"></div>

      <nav className="nav-container">
        <div className="logo">Arcadia</div>

        <div className="menu-icon" onClick={toggleMobileMenu}>
          <div className={`bar ${mobileMenuOpen ? "open" : ""}`}></div>
          <div className={`bar ${mobileMenuOpen ? "open" : ""}`}></div>
          <div className={`bar ${mobileMenuOpen ? "open" : ""}`}></div>
        </div>

        <div className={`nav-links ${mobileMenuOpen ? "open" : ""}`}>
          <a href="#games" onClick={() => setMobileMenuOpen(false)}>
            Games
          </a>
          <a href="#features" onClick={() => setMobileMenuOpen(false)}>
            Features
          </a>
          <a href="#how-it-works" onClick={() => setMobileMenuOpen(false)}>
            How It Works
          </a>
          <a href="#faq" onClick={() => setMobileMenuOpen(false)}>
            FAQ
          </a>
        </div>
      </nav>

      <div className={`hero-content ${isVisible ? "visible" : ""}`}>
        <h1>
          Boost your Pi mining rate
          <span className="highlight"> by playing games</span>
        </h1>
        <p>
          Discover a new way to play online games. Direct connections between
          players. No servers, just pure gaming fun.
        </p>
        <div className="button-container">
          <button className="primary-button" onClick={startNow}>
            Start Playing Now
          </button>
          <DonateButton />
        </div>
      </div>

      <div className="scroll-indicator">
        <svg
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7 13l5 5 5-5M7 7l5 5 5-5" />
        </svg>
      </div>

      <style>{`
        .header {
          height: 100vh;
          width: 100vw;
          background: linear-gradient(
            135deg,
            #0f0c29 0%,
            #302b63 50%,
            #24243e 100%
          );
          color: white;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0;
          position: relative;
          text-align: center;
          overflow: hidden;
        }

        .background-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: url("/api/placeholder/1200/800") center/cover no-repeat;
          opacity: 0.2;
          z-index: 1;
        }

        .nav-container {
          position: absolute;
          top: 16px;
          left:0;
          width: 100%;
          padding-left: 20px;
          padding-right: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 100;
        }

        .logo {
          font-size: 24px;
          padding-left: 10px;
          font-weight: bold;
          letter-spacing: 1px;
          z-index: 101;
        }

        .nav-links {
          display: flex;
          gap: 20px;
          padding-right: 10px;
          justify-content: flex-end;
        }

        .nav-links a {
          color: white;
          text-decoration: none;
          font-size: 16px;
          transition: color 0.3s ease;
        }

        .nav-links a:hover {
          color: #61dafb;
        }

        .menu-icon {
          display: none;
          flex-direction: column;
          justify-content: space-between;
          width: 30px;
          height: 21px;
          cursor: pointer;
          z-index: 101;
          padding-right: 10px;
        }

        .bar {
          height: 3px;
          width: 100%;
          background-color: white;
          border-radius: 3px;
          transition: all 0.3s ease-in-out;
        }

        .hero-content {
          z-index: 10;
          opacity: 0;
          transform: translateY(20px);
          transition: opacity 1s ease, transform 1s ease;
          max-width: 800px;
          padding: 0 20px;
        }

        .hero-content.visible {
          opacity: 1;
          transform: translateY(0);
        }

        h1 {
          font-size: clamp(2.5rem, 5vw, 4rem);
          font-weight: 800;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .highlight {
          color: #61dafb;
        }

        p {
          font-size: clamp(1rem, 2vw, 1.5rem);
          line-height: 1.6;
          margin-bottom: 40px;
          max-width: 800px;
        }

        .button-container {
          display: flex;
          gap: 20px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .primary-button {
          background: #61dafb;
          color: #1a1a2e;
          border: none;
          padding: 15px 30px;
          font-size: 18px;
          font-weight: bold;
          border-radius: 8px;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s;
          box-shadow: 0 4px 12px rgba(97, 218, 251, 0.25);
        }

        .primary-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(97, 218, 251, 0.35);
        }

        .secondary-button {
          background: transparent;
          color: white;
          border: 2px solid #61dafb;
          padding: 15px 30px;
          font-size: 18px;
          font-weight: bold;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.2s, transform 0.2s;
        }

        .secondary-button:hover {
          background: rgba(97, 218, 251, 0.1);
          transform: translateY(-2px);
        }

        .scroll-indicator {
          position: absolute;
          bottom: 40px;
          left: 50%;
          transform: translateX(-50%);
          animation: bounce 2s infinite;
          z-index: 10;
        }

        @keyframes bounce {
          0%,
          20%,
          50%,
          80%,
          100% {
            transform: translateX(-50%) translateY(0);
          }
          40% {
            transform: translateX(-50%) translateY(-10px);
          }
          60% {
            transform: translateX(-50%) translateY(-5px);
          }
        }

        /* Mobile styles */
        @media (max-width: 768px) {
          .menu-icon {
            display: flex;
          }

          .nav-links {
            position: fixed;
            top: 0;
            right: -100%;
            height: 100vh;
            width: 70%;
            max-width: 300px;
            background: rgba(15, 12, 41, 0.95);
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 40px;
            padding: 80px 0;
            transition: right 0.4s ease;
            backdrop-filter: blur(10px);
            box-shadow: -5px 0 20px rgba(0, 0, 0, 0.3);
            z-index: 100;
          }

          .nav-links.open {
            right: 0;
          }

          .nav-links a {
            font-size: 20px;
            font-weight: 500;
          }

          /* Transform hamburger to X */
          .bar.open:nth-child(1) {
            transform: translateY(9px) rotate(45deg);
          }

          .bar.open:nth-child(2) {
            opacity: 0;
          }

          .bar.open:nth-child(3) {
            transform: translateY(-9px) rotate(-45deg);
          }

          /* Adjust button sizes */
          .primary-button,
          .secondary-button {
            width: 100%;
            max-width: 250px;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
